import {
    API_PASARELA_PAGOS_REGISTRAR,
    API_PASARELA_PAGOS_RESULTADO,
  } from "../../config/constantes";
  
  // Registra el intento de pago en el backend upch-0002-api-matricula-pagos,
  // que llama a POST /pasarela/registro y devuelve { uuid, url } (url = widget PayMe).
  let registrarPagoPasarela = async (payload) => {
    let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos?.access_token,
      },
      body: JSON.stringify(payload),
    };
  
    const response = await fetch(`${API_PASARELA_PAGOS_REGISTRAR}`, config);
    const data = await response.json();
  
    console.log("[DEBUG registrarPagoPasarela] Status:", response.status);
    console.log("[DEBUG registrarPagoPasarela] Respuesta completa:", data);
  
    if (!response.ok || !data?.url) {
      throw new Error(
        data?.mensaje || "La pasarela de pagos no devolvió la URL de pago."
      );
    }
  
    return data;
  };
  
  // Consulta el resultado del pago con el token JWT que la pasarela
  // devuelve en la url_respuesta (?token=). No requiere sesión.
  let consultarResultadoPago = async (token) => {
    const config = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
  
    const response = await fetch(
      `${API_PASARELA_PAGOS_RESULTADO}?token=${encodeURIComponent(token)}`,
      config
    );
    const data = await response.json();
  
    if (!response.ok) {
      throw new Error(data?.mensaje || "No se pudo consultar el resultado del pago.");
    }
  
    return data;
  };
  
  export { registrarPagoPasarela, consultarResultadoPago };